import { FunctionComponent } from "react";
import styled from "styled-components";
import { KycIcon } from "../../../../components/icons/status";
import { Grid } from "../../../../components/layout";
import { Resource } from "../../../../components/loader/resource";
import { useKycHistoryQuery } from "../../../../store/verification/queries";
import { colours } from "../../../../styles/colours";

interface IKycHistoryProps {
  fraudCheckId: string;
}

const Entry = styled(Grid).attrs({ ["col-xs"]: 2 })`
  padding: 1em;
  margin: 0.5em 0;

  &:nth-child(2n) {
    background: ${colours.lightBlue};
  }
`;

const Row = styled(Grid).attrs({ ["col-xs"]: 2 })`
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 1em;
  }
`;

const KycHistory: FunctionComponent<IKycHistoryProps> = ({ fraudCheckId }) => {
  const resource = useKycHistoryQuery(fraudCheckId);

  return (
    <Resource r={resource}>
      {(data) => (
        <div>
          {data
            .slice()
            .sort((x, y) => y.changedAt.diff(x.changedAt))
            .map(
              (
                {
                  changedAt,
                  changedBy,
                  mainStatus,
                  note,
                  addressStatus,
                  amlStatus,
                  consentStatus,
                  documentStatus,
                  faceStatus,
                },
                index
              ) => (
                <Entry col-xs={2} key={index}>
                  <Row col-xs={2}>
                    <strong>Main status</strong>{" "}
                    <div>{KycIcon(mainStatus, "kyc")}</div>
                    <strong>Changed at</strong>
                    <div>{changedAt.local().format("yyyy-MM-DD HH:mm")}</div>
                    <strong>Changed by</strong>
                    <div>
                      {changedBy === "AUTOMATED"
                        ? "System generated"
                        : changedBy}
                    </div>
                    {changedBy !== "AUTOMATED" ? (
                      <>
                        <strong>Note</strong>
                        <div>{note}</div>
                      </>
                    ) : null}
                  </Row>
                  <Row col-xs={2}>
                    <strong>Address</strong>
                    <div>{KycIcon(addressStatus, "kyc")}</div>
                    <strong>AML</strong>
                    <div>{KycIcon(amlStatus, "kyc")}</div>
                    <strong>Consent</strong>
                    <div>{KycIcon(consentStatus, "kyc")}</div>
                    <strong>Document</strong>
                    <div>{KycIcon(documentStatus, "kyc")}</div>
                    <strong>Face</strong>
                    <div>{KycIcon(faceStatus, "kyc")}</div>
                  </Row>
                </Entry>
              )
            )}
        </div>
      )}
    </Resource>
  );
};

export default KycHistory;
